import React, { memo } from 'react';
import cls from './LogsListHeader.module.scss';

const LogsListHeader = memo(() => {
  return (
    <div className={cls.Header} data-testid="header-list">
      <span className={cls.Item} id="number">
        Number
      </span>
      <span className={cls.Item} id="createdAt">
        Date
      </span>
      <span className={cls.Item} id="ip">
        IP Address
      </span>
      <span className={cls.Item} id="description">
        Event
      </span>
    </div>
  );
});

export default LogsListHeader;
